// Toast 提示组件

import { create } from 'zustand';
import { useEffect } from 'react';

interface Toast {
  id: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
}

interface ToastState {
  toasts: Toast[];
  show: (message: string, type?: Toast['type']) => void;
  remove: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  show: (message, type = 'info') => {
    const id = crypto.randomUUID();
    set((s) => ({ toasts: [...s.toasts, { id, message, type }] }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, 3000);
  },
  remove: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export function ToastContainer() {
  const { toasts } = useToastStore();
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2 items-center">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>
  );
}

function ToastItem({ toast }: { toast: Toast }) {
  const { remove } = useToastStore();
  useEffect(() => {
    const t = setTimeout(() => remove(toast.id), 3000);
    return () => clearTimeout(t);
  }, [toast.id, remove]);

  const colors: Record<Toast['type'], string> = {
    info: 'bg-ink/90 text-white',
    success: 'bg-success/90 text-white',
    warning: 'bg-warning/90 text-white',
    error: 'bg-danger/90 text-white',
  };
  const icons: Record<Toast['type'], string> = {
    info: 'ℹ️',
    success: '✓',
    warning: '⚠️',
    error: '✗',
  };

  return (
    <div
      className={`px-4 py-2.5 rounded-md shadow-pop text-sm animate-slide-up flex items-center gap-2 ${colors[toast.type]}`}
    >
      <span>{icons[toast.type]}</span>
      <span>{toast.message}</span>
    </div>
  );
}
